import React from "react";

/**
 * Criterio visual del tab Social:
 * - Seleccionable (filtra): solo el selector de plataforma y los controles de la barra de filtros.
 *   Son botones con borde y, en las plataformas, punto de color.
 * - Informativo (no filtra): `SocialBadge`. Pastilla plana, sin borde, sin punto, sin cursor de acción.
 */
export type BadgeTone = "danger" | "warning" | "success" | "neutral" | "info";

const TONES: Record<BadgeTone, { bg: string; color: string }> = {
  danger: { bg: "rgba(255, 102, 94, 0.16)", color: "#ff8a83" },
  warning: { bg: "rgba(247, 189, 91, 0.14)", color: "#f7bd5b" },
  success: { bg: "rgba(75, 212, 160, 0.14)", color: "#4bd4a0" },
  neutral: { bg: "rgba(142, 150, 168, 0.14)", color: "var(--muted, #8e96a8)" },
  info: { bg: "rgba(125, 150, 255, 0.14)", color: "#9fb2ff" },
};

interface Props {
  tone?: BadgeTone;
  title?: string;
  children: React.ReactNode;
}

export function SocialBadge({ tone = "neutral", title, children }: Props) {
  return (
    <span
      title={title}
      className={`social-badge tone-${tone}`}
    >
      {children}
    </span>
  );
}
